// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3pwiW","header":"ReportDetails_header__1ysm0","title":"ReportDetails_title__3JCcb","left":"ReportDetails_left__27FZL"};